import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { Collapse } from 'reactstrap';

import 'assets/scss/soonoGetStarted.css';
import SelectPlanWrapper from './SelectPlanWrapper';

const PAYMENT_INTERVALS = {
  MONTHLY: 'monthly',
  YEARLY: 'annual',
};

class PaidPlan extends Component {
  constructor() {
    super();
    this.state = {
      currentPlan: 'proPlan',
      basicPlan: {
        id: 3,
        interval: PAYMENT_INTERVALS.MONTHLY,
        status: 'active',
      },
      proPlan: {
        id: 4,
        interval: PAYMENT_INTERVALS.MONTHLY,
        status: 'active',
      },
      proToggle: false,
      basicToggle: false,
    };
  }

  onProToggle = () => {
    this.setState(({ proToggle }) => ({
      proToggle: !proToggle,
    }));
  };

  onBasicToggle = () => {
    this.setState(({ basicToggle }) => ({
      basicToggle: !basicToggle,
    }));
  };

  onIntervalChanged = e => {
    const { name, value } = e.target;
    const _plan = { ...this.state[name] };
    _plan.interval = value;
    this.setState({ [name]: { ..._plan }, currentPlan: name });
  };

  onBasicPlanSelected = () => {
    const { basicPlan } = this.state;
    this.props.onBasicPlanSelected(basicPlan);
  };

  onProPlanSelected = () => {
    const { proPlan } = this.state;
    this.props.onProPlanSelected(proPlan);
  };

  render() {
    const { togglePlan, renew, basicPlanDisabled } = this.props;
    const {
      proPlan,
      basicPlan,
      currentPlan,
      proToggle,
      basicToggle,
    } = this.state;

    return (
      <SelectPlanWrapper renew={renew}>
        <div className="col-lg-6 col-md-12">
          <div
            className={`card package-card border-0 p-lg-2 p-0 mb-3 ${
              !basicPlanDisabled
                ? 'bg-gradient-professional'
                : 'bg-gradient-standard'
            } `}
          >
            <div className="card-body pt-5 pb-4">
              <h2 className="card-title text-bold text-white">Basic Plan</h2>
              <h6 className="card-text mb-4 text-white">
                You will be charged after 7 days trial
              </h6>
              <div className="card pt-5 pl-3 pr-3 pb-4 border-0 shadow-3">
                <div className="row mb-3">
                  <div className="col text-center mb-1">
                    {basicPlan.interval == PAYMENT_INTERVALS.YEARLY ? (
                      <h1 className="text-bold">
                        $ 1015
                        <span className="text-secondary"> / Save 5% off</span>
                      </h1>
                    ) : (
                      <h1 className="text-bold">$ 89</h1>
                    )}
                    <div
                      className="btn-group btn-group-toggle mt-2"
                      data-toggle="buttons"
                    >
                      <label
                        className={`btn ${
                          basicPlan.interval == PAYMENT_INTERVALS.MONTHLY
                            ? 'btn-primary active'
                            : 'btn-outline-secondary'
                        }  pr-4 pl-4 toggle-btn-left text-bold`}
                      >
                        <input
                          type="radio"
                          name="basicPlan"
                          autocomplete="off"
                          value={PAYMENT_INTERVALS.MONTHLY}
                          // checked={interval == PAYMENT_INTERVALS.MONTHLY}
                          onClick={this.onIntervalChanged}
                          disabled={basicPlanDisabled}
                        />{' '}
                        Monthly
                      </label>
                      <label
                        className={`btn ${
                          basicPlan.interval == PAYMENT_INTERVALS.YEARLY
                            ? 'btn-primary active'
                            : 'btn-outline-secondary'
                        }  pr-4 pl-4 toggle-btn-right text-bold`}
                      >
                        <input
                          type="radio"
                          name="basicPlan"
                          autocomplete="off"
                          value={PAYMENT_INTERVALS.YEARLY}
                          // checked={interval == PAYMENT_INTERVALS.YEARLY}
                          onClick={this.onIntervalChanged}
                          disabled={basicPlanDisabled}
                        />{' '}
                        Yearly
                      </label>
                    </div>
                  </div>
                </div>
                <ul className="package-features text-left p-lg-2 p-0">
                  <li>
                    <FontAwesomeIcon
                      icon="check-circle"
                      className="text-success steps-icon"
                    />{' '}
                    Survey's
                    <span className="float-right text-bold">10</span>
                  </li>
                  <li>
                    <FontAwesomeIcon
                      icon="check-circle"
                      className="text-success steps-icon"
                    />{' '}
                    Survey participants
                    <span className="float-right text-bold">1000</span>
                  </li>
                  <li>
                    <FontAwesomeIcon
                      icon="check-circle"
                      className="text-success steps-icon"
                    />{' '}
                    User accounts
                    <span className="float-right text-bold">2</span>
                  </li>
                  <Collapse isOpen={basicToggle} className="plan-information">
                    <li>
                      <FontAwesomeIcon
                        icon="check-circle"
                        className="text-success steps-icon"
                      />{' '}
                      1-on-1 consulation fee
                      <span className="float-right text-bold">$399</span>
                    </li>
                    <li>
                      <FontAwesomeIcon
                        icon="check-circle"
                        className="text-success steps-icon"
                      />{' '}
                      Onboarding
                    </li>
                    <li>
                      <FontAwesomeIcon
                        icon="check-circle"
                        className="text-success steps-icon"
                      />{' '}
                      Customer support
                    </li>
                    <li className="text-secondary">
                      <FontAwesomeIcon
                        icon="times-circle"
                        className="text-danger steps-icon"
                      />{' '}
                      Growth Add-Ons
                    </li>
                    <li className="text-secondary">
                      <FontAwesomeIcon
                        icon="times-circle"
                        className="text-danger steps-icon"
                      />{' '}
                      SMS short code Add-On
                    </li>
                  </Collapse>
                  <li
                    className="text-center plan-toggler"
                    id="basicToggler"
                    onClick={this.onBasicToggle}
                  >
                    <FontAwesomeIcon
                      icon={basicToggle ? 'angle-up' : 'angle-down'}
                    />
                  </li>
                </ul>
                <button
                  className="btn btn-warning col-md-12 py-3 pl-5 pr-5 mt-3 text-white text-bold border-0"
                  type="button"
                  onClick={this.onBasicPlanSelected}
                  disabled={basicPlanDisabled}
                >
                  Select plan
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-md-12">
          <div
            className={`card package-card border-0 p-lg-2 p-0 ${
              currentPlan ? 'bg-gradient-professional' : 'bg-gradient-standard'
            }`}
          >
            <div class="ribbon ribbon-top-right">
              <span>Best Value</span>
            </div>
            <div className="card-body pt-5 pb-4">
              <h2 className="card-title text-bold text-white">Pro Plan</h2>
              <h6 className="card-text mb-4 text-white">
                You will be charged after 7 days trial
              </h6>
              <div className="card pt-5 pl-3 pr-3 pb-4 border-0 shadow-3">
                <div className="row mb-3">
                  <div className="col text-center mb-1">
                    {proPlan.interval == PAYMENT_INTERVALS.YEARLY ? (
                      <h1 className="text-bold">
                        $ 1389
                        <span className="text-secondary"> / Save 10% off</span>
                      </h1>
                    ) : (
                      <h1 className="text-bold">$ 129</h1>
                    )}
                    <div
                      className="btn-group btn-group-toggle mt-2"
                      data-toggle="buttons"
                    >
                      <label
                        className={`btn ${
                          proPlan.interval == PAYMENT_INTERVALS.MONTHLY
                            ? 'btn-primary active'
                            : 'btn-outline-secondary'
                        }  pr-4 pl-4 toggle-btn-left text-bold`}
                      >
                        <input
                          type="radio"
                          name="proPlan"
                          autocomplete="off"
                          value={PAYMENT_INTERVALS.MONTHLY}
                          checked={
                            proPlan.interval == PAYMENT_INTERVALS.MONTHLY
                          }
                          onClick={this.onIntervalChanged}
                        />{' '}
                        Monthly
                      </label>
                      <label
                        className={`btn ${
                          proPlan.interval == PAYMENT_INTERVALS.YEARLY
                            ? 'btn-primary active'
                            : 'btn-outline-secondary'
                        }  pr-4 pl-4 toggle-btn-right text-bold`}
                      >
                        <input
                          type="radio"
                          name="proPlan"
                          value={PAYMENT_INTERVALS.YEARLY}
                          autocomplete="off"
                          checked={proPlan.interval == PAYMENT_INTERVALS.YEARLY}
                          onClick={this.onIntervalChanged}
                        />{' '}
                        Yearly
                      </label>
                    </div>
                  </div>
                </div>
                <ul className="package-features text-left p-lg-2 p-0">
                  <li>
                    <FontAwesomeIcon
                      icon="check-circle"
                      className="text-success steps-icon"
                    />{' '}
                    Survey's
                    <span className="float-right">
                      <FontAwesomeIcon icon="infinity" />
                    </span>
                  </li>
                  <li>
                    <FontAwesomeIcon
                      icon="check-circle"
                      className="text-success steps-icon"
                    />{' '}
                    Survey participants
                    <span className="float-right">
                      <FontAwesomeIcon icon="infinity" />
                    </span>
                  </li>
                  <li>
                    <FontAwesomeIcon
                      icon="check-circle"
                      className="text-success steps-icon"
                    />{' '}
                    User accounts
                    <span className="float-right">
                      <FontAwesomeIcon icon="infinity" />
                    </span>
                  </li>
                  <Collapse isOpen={proToggle} className="plan-information">
                    <li>
                      <FontAwesomeIcon
                        icon="check-circle"
                        className="text-success steps-icon"
                      />{' '}
                      1-on-1 consulation fee
                      <span className="float-right text-bold">$199</span>
                    </li>
                    <li>
                      <FontAwesomeIcon
                        icon="check-circle"
                        className="text-success steps-icon"
                      />{' '}
                      Onboarding
                    </li>
                    <li>
                      <FontAwesomeIcon
                        icon="check-circle"
                        className="text-success steps-icon"
                      />{' '}
                      Customer support
                    </li>
                    <li>
                      <FontAwesomeIcon
                        icon="check-circle"
                        className="text-success steps-icon"
                      />{' '}
                      Growth Add-Ons
                    </li>
                    <li>
                      <FontAwesomeIcon
                        icon="check-circle"
                        className="text-success steps-icon"
                      />{' '}
                      SMS short code Add-On
                    </li>
                  </Collapse>
                  <li
                    className="text-center plan-toggler"
                    id="proToggler"
                    onClick={this.onProToggle}
                  >
                    <FontAwesomeIcon
                      icon={proToggle ? 'angle-up' : 'angle-down'}
                    />
                  </li>
                </ul>
                <button
                  className="btn btn-warning col-md-12 py-3 pl-5 pr-5 mt-3 text-white text-bold border-0"
                  type="button"
                  onClick={this.onProPlanSelected}
                >
                  Select plan
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className={`col-md-12 mt-5 ${renew && 'd-none'}`}>
          <p>
            Want to try Soono Survey before purchasing? &nbsp;
            <div
              className="text-bold text-primary cursor-pointer"
              onClick={togglePlan}
            >
              Start your free 7 day trial.
            </div>
          </p>
        </div>
      </SelectPlanWrapper>
    );
  }
}

export default withRouter(PaidPlan);



// WEBPACK FOOTER //
// ./src/components/transactions/PaidPlan.js